/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_HerkunftslandInputs */

const en__field_herkunftsland = /** @type {(inputs: _Field_HerkunftslandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Native Country`)
};

const de__field_herkunftsland = /** @type {(inputs: _Field_HerkunftslandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herkunftsland`)
};

/**
* | output |
* | --- |
* | "Native Country" |
*
* @param {_Field_HerkunftslandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_herkunftsland = /** @type {((inputs?: _Field_HerkunftslandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_HerkunftslandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_herkunftsland(inputs)
	return de__field_herkunftsland(inputs)
});